"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Spec = exports.NAMESPACE = void 0;
const platform_1 = require("@effect/platform");
const effect_1 = require("effect");
const Device = __importStar(require("../../../../../../device"));
const User = __importStar(require("../../../../../../user"));
const openapi_1 = require("../../../../../openapi");
const Schema = __importStar(require("./schema"));
exports.NAMESPACE = 'Culligan.Api.V2.Spec.Legacy.Device.Manufacturing.Spec';
const Role = User.GlobalUserRole.enums;
/**
 * Administrators only until the factory operators have a role of their own:
 * the brand roles are scoped to their own brand everywhere else, and a
 * provisioning record carries no brand to scope by.
 */
const withAdmins = openapi_1.Security.v1Roles(Role.SystemAdmin, Role.Admin);
const ProvisioningRecordResponse = openapi_1.Response.Success(Device.Manufacturing.ProvisioningRecord).annotations({
    description: 'The provisioning record that was stored',
});
const ProvisioningRecordListResponse = openapi_1.Response.Success(Schema.ProvisioningRecordList).annotations({
    description: 'Provisioning records matching the query',
});
const DisabledRecordResponse = openapi_1.Response.Success(Schema.DisabledProvisioningRecord).annotations({
    description: 'The disabled record. A repeat of a call that already succeeded returns the existing disabled record.',
});
/**
 * A v1 failure whose `message` is a machine-readable code that the handler also
 * repeats as `error.code`, with optional detail under `error.data`.
 */
const codedFailure = (identifier, status, title, description, codes, data) => effect_1.Schema.Struct({
    success: effect_1.Schema.Literal(false),
    error: effect_1.Schema.Struct({
        message: effect_1.Schema.Literal(...codes),
        code: effect_1.Schema.Literal(...codes),
        data: effect_1.Schema.optionalWith(data, { exact: true }),
    }),
}).annotations({
    identifier: `${exports.NAMESPACE}.${identifier}`,
    title,
    description,
    [platform_1.HttpApiSchema.AnnotationStatus]: status,
});
const MessageData = effect_1.Schema.Struct({ message: effect_1.Schema.String });
/** 422 of POST and DELETE: the handlers send `code` next to `inputValidation`. */
const InvalidRequest = openapi_1.Error.v1LegacyValidationWith(`${exports.NAMESPACE}.InvalidRequest`, 'Validation Error', 'One of the request entities does not satisfy validation rules. The manufacturing handlers also repeat the error code as `error.code`.', { code: effect_1.Schema.Literal('INVALID_REQUEST') });
/** 409 of POST: the first supplied code, in the order MSN, DSN, asset tag, that is already provisioned. */
const AlreadyProvisioned = codedFailure('AlreadyProvisioned', 409, 'Already Provisioned', 'The manufacturing serial number, device serial number or asset tag is already provisioned. Checked against active provisioning records only. A concurrent insert of the same MSN is reported the same way, without `data`.', ['MSN_ALREADY_PROVISIONED', 'DSN_ALREADY_PROVISIONED', 'ASSET_TAG_ALREADY_PROVISIONED'], MessageData);
/** 422 of GET without `inputValidation`: no filter, an unparsable date or a reversed range. */
const InvalidQuery = openapi_1.Error.v1Rejected(`${exports.NAMESPACE}.InvalidQuery`, 'INVALID_REQUEST', 'Invalid Query', 'No filter was given, a date is not YYYY-MM-DD or an ISO date-time with an offset, or startDate is after endDate. Carries no express-validator field errors.', {
    code: effect_1.Schema.Literal('INVALID_REQUEST'),
    data: effect_1.Schema.optionalWith(MessageData, { exact: true }),
});
const ResultSetTooLarge = openapi_1.Error.v1Rejected(`${exports.NAMESPACE}.ResultSetTooLarge`, 'RESULT_SET_TOO_LARGE', 'Result Set Too Large', 'More than 1000 records match. The list is refused rather than truncated; narrow the range and repeat.', {
    code: effect_1.Schema.Literal('RESULT_SET_TOO_LARGE'),
    data: effect_1.Schema.Struct({
        message: effect_1.Schema.String,
        limit: effect_1.Schema.propertySignature(effect_1.Schema.Number.annotations({ description: 'The largest page the query returns' })).annotations({ description: 'The largest page the query returns' }),
    }),
});
const RecordNotFound = codedFailure('RecordNotFound', 404, 'Provisioning Record Not Found', 'No active provisioning record exists for the manufacturing serial number, and none was disabled earlier.', ['PROVISIONING_RECORD_NOT_FOUND'], MessageData);
const RecordMismatch = effect_1.Schema.Struct({
    success: effect_1.Schema.Literal(false),
    error: effect_1.Schema.Struct({
        message: effect_1.Schema.Literal('PROVISIONING_RECORD_MISMATCH'),
        code: effect_1.Schema.Literal('PROVISIONING_RECORD_MISMATCH'),
        data: effect_1.Schema.Struct({
            message: effect_1.Schema.String,
            field: effect_1.Schema.propertySignature(effect_1.Schema.Literal('dsn', 'assetTag').annotations({
                description: 'The supplied field that disagrees with the stored record',
            })).annotations({ description: 'The supplied field that disagrees with the stored record' }),
        }),
    }),
}).annotations({
    identifier: `${exports.NAMESPACE}.RecordMismatch`,
    title: 'Provisioning Record Mismatch',
    description: 'The supplied DSN or asset tag does not match the stored record. The stored value is logged, not returned.',
    [platform_1.HttpApiSchema.AnnotationStatus]: 409,
});
const createProvisioningRecord = platform_1.HttpApiEndpoint.post('createProvisioningRecord') `/manufacturing`
    .setPayload(Schema.CreateProvisioningRecordPayload)
    .addSuccess(ProvisioningRecordResponse)
    .addError(InvalidRequest)
    .addError(AlreadyProvisioned)
    .annotate(platform_1.OpenApi.Title, 'Create Provisioning Record')
    .annotate(platform_1.OpenApi.Description, "Stores the manufacturing data of a device and returns the record, stamped with the time and request.ip. Express does not trust a proxy, so this is the immediate peer, not the caller's public IP. An omitted optional value is stored as null. The factory key, as the `key` query parameter, or an administrator bearer token is accepted; the key is tried first.")
    .middleware(openapi_1.Security.V1FactoryKey)
    .pipe(withAdmins, openapi_1.Error.withV1StandardErrors);
const listProvisioningRecords = platform_1.HttpApiEndpoint.get('listProvisioningRecords') `/manufacturing`
    .setUrlParams(Schema.ProvisioningRecordQuery)
    .addSuccess(ProvisioningRecordListResponse)
    .addError(InvalidQuery)
    .addError(ResultSetTooLarge)
    .annotate(platform_1.OpenApi.Title, 'List Provisioning Records')
    .annotate(platform_1.OpenApi.Description, 'Returns the provisioning records matching the query, oldest manufacturedAt first. At least one filter is required. A record matching any one of dsn, msn or assetTag is returned, and the date bounds narrow that set. Dates compare in UTC, and a bare endDate ends at 23:59:59.999Z, so pass an explicit offset to cover a local production day. More than 1000 matches is 422 RESULT_SET_TOO_LARGE, not a truncated list. The factory key or an administrator bearer token is accepted.')
    .middleware(openapi_1.Security.V1FactoryKey)
    .pipe(withAdmins, openapi_1.Error.withV1StandardErrors);
const disableProvisioningRecord = platform_1.HttpApiEndpoint.del('disableProvisioningRecord') `/manufacturing`
    .setPayload(Schema.DisableProvisioningRecordPayload)
    .addSuccess(DisabledRecordResponse)
    .addError(InvalidRequest)
    .addError(RecordNotFound)
    .addError(RecordMismatch)
    .annotate(platform_1.OpenApi.Title, 'Disable Provisioning Record')
    .annotate(platform_1.OpenApi.Description, 'Soft-disables the active provisioning record of a manufacturing serial number, releasing its MSN, DSN and asset tag for reuse. A copy carrying every original field plus the disabled fields is stored under a new id and the original is removed. Safe to retry: a repeat returns the existing disabled record. dsn and assetTag are verified when supplied, and the check runs on an active record only. The factory key or an administrator bearer token is accepted; a request carrying both is admitted by the key, and disabledBy then records the key, not the person.')
    .middleware(openapi_1.Security.V1FactoryKey)
    .pipe(withAdmins, openapi_1.Error.withV1StandardErrors);
exports.Spec = platform_1.HttpApiGroup.make('v2.device.manufacturing')
    .add(createProvisioningRecord)
    .add(listProvisioningRecords)
    .add(disableProvisioningRecord)
    .prefix('/device')
    .annotate(platform_1.OpenApi.Title, 'Device Manufacturing')
    .annotate(platform_1.OpenApi.Description, 'Provisioning records of manufactured devices, for the factory and for administrators')
    .pipe(openapi_1.Audience.withAudiences(openapi_1.Audience.Audience.Device));
//# sourceMappingURL=spec.js.map